import React, { Component } from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import { FormattedMessage } from 'react-intl'
import RawHtml from 'stories/components/RawHtml'

import './email-input.css'

export default class EmailVerification extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasFocus: false,
    }
  }

  onInputChange = (event) => {
    const { value } = event.target
    this.props.onChange(value.trim())
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () => {
    return this.props.value
  }

  sendCodeButton = () => (
    <div className="verification-send-code">
      <FormattedMessage id="form.fields.email.verification.sendCodeButton" />
    </div>
  )
  render() {
    const {
      label = '',
      name = '',
      placeholder = '',
      required,
      touched,
      error,
      description,
    } = this.props

    const classNames = {
      'formz-email-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }
    const inputProps = {
      name,
      value: this.getInputValue(),
      onChange: this.onInputChange,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
    }
    return (
      <FieldRowWrapper
        className={classNames}
        error={error}
        touched={touched ? touched.toString() : undefined}
      >
        <label className="formz-field-and-label-holder">
          <div className="formz-input-title">
            {label} {required && '(*)'}
          </div>

          <RawHtml className="formz-field-description" content={description} />
          <div className="formz-input-field email-verification-input">
            <input
              {...inputProps}
              placeholder={placeholder}
              className="ltr-on-type"
            />
            {this.sendCodeButton()}
          </div>
        </label>
      </FieldRowWrapper>
    )
  }
}
